export const propertyGridWhitelist = {
   radioPropsWhitelist: [
      'title',
      'name',
      'correctAnswer',
      'isRequired',
      'description',
      'choices',
      'otherItem',
      'showOtherItem',
      'otherText',
      'noneItem',
      'noneText',
      'showNoneItem',
   ],
   boolPropsWhitelist: ['title', 'name', 'correctAnswer', 'isRequired', 'description'],
   textPropsWhitelist: [
      'title',
      'name',
      'correctAnswer',
      'isRequired',
      'description',
      'numberTolerance',
   ],
   surveyPropsWhitelist: ['title', 'name', 'description', 'questionsOrder', 'quizEnabledStatus'],
   pagePropsWhitelist: ['title', 'name'],
   itemValuePropsWhitelist: ['icon', 'text'],
   imageItemValuePropsWhitelist: ['text', 'imageLink', 'altText'],
   imagePropsWhitelist: [
      'title',
      'name',
      'altText',
      'contentMode',
      'imageFit',
      'imageHeight',
      'imageWidth',
      'imageLink',
      'caption',
   ],
   imagePickerPropsWhitelist: [
      'title',
      'name',
      'correctAnswer',
      'isRequired',
      'description',
      'choices',
   ],
};
